import {
  Row,
  Col,
  Space,
  Segmented,
  Button,
  Tooltip,
  DatePicker,
} from "antd";
import get from "lodash/get";
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
import { generateInjectionMouldingDayGraphPdf } from "../../utilities/pdf/injectionMouldingDayGraphPdf";
import dayjs from "dayjs";
import {
  getCurrentDateRange,
  customWeekStartEndFormat,
} from "../../utilities/report";
import { getFileNameInitials } from "../../utilities/helpers";
import DayGraphContentContainer from "./dayGraphContentContainer";

const DayGraphSection = ({
  selectedTemplate,
  onChangeParams,
  filter,
  setLoading,
}) => {
  const data = get(selectedTemplate, "graph_report");
  return (
    <>
      <Row justify={"end"} className="mt-2 mb-10">
        <Col>
          <Space>
            {get(selectedTemplate, "interval") === "week" ? (
              <DatePicker
                onChange={(value, dateString) => {
                  onChangeParams(
                    get(selectedTemplate, "template"),
                    get(selectedTemplate, "interval"),
                    getCurrentDateRange(
                      get(selectedTemplate, "interval"),
                      value
                    )
                  );
                }}
                format={customWeekStartEndFormat}
                showWeek={false}
                value={dayjs(get(selectedTemplate, "date.0"), "YYYY-MM-DD")}
                picker="week"
              />
            ) : (
              <DatePicker
                onChange={(value, dateString) => {
                  onChangeParams(
                    get(selectedTemplate, "template"),
                    get(selectedTemplate, "interval"),
                    getCurrentDateRange(
                      get(selectedTemplate, "interval"),
                      value
                    )
                  );
                }}
                value={dayjs(get(selectedTemplate, "date.0"), "YYYY-MM-DD")}
                picker="month"
                format={"MM-YYYY"}
              />
            )}
            <Segmented
              className="bg-gray-200"
              options={[
                { label: "Weekly", value: "week" },
                { label: "Monthly", value: "month" },
              ]}
              value={get(selectedTemplate, "interval")}
              defaultValue={"week"}
              onChange={(interval) => {
                onChangeParams(
                  get(selectedTemplate, "template"),
                  interval,
                  getCurrentDateRange(interval, dayjs())
                );
              }}
            />
            <Tooltip title="Refresh Statistics">
              <Button
                type="primary"
                icon={<ReloadOutlined />}
                onClick={() => {
                  onChangeParams(
                    get(selectedTemplate, "template"),
                    get(selectedTemplate, "interval"),
                    get(selectedTemplate, "date")
                  );
                }}
              />
            </Tooltip>

            <Tooltip title="Download Report">
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={() =>
                  generateInjectionMouldingDayGraphPdf(
                    selectedTemplate,
                    filter,
                    setLoading,
                    getFileNameInitials("day-graph", {
                      tempalteName: get(selectedTemplate, "template.name"),
                      shiftName: undefined,
                      companyName: get(filter, "company.name"),
                      date: get(selectedTemplate, "date"),
                    })
                  )
                }
              />
            </Tooltip>
          </Space>
        </Col>
      </Row>
      <DayGraphContentContainer
        selectedTemplate={selectedTemplate} filter={filter} data={data} />
    </>
  );
};

export default DayGraphSection;
